import React from 'react'
import { ActivityIndicatorProps, TouchableWithoutFeedback } from 'react-native'
import ActivityIndicator from 'APP/Components/ActivityIndicator'
import { Container, Backdrop, SpinnerWrapper } from './Spinner.styles'
import { useTheme } from 'styled-components/native'
import { Modal } from 'react-native'

export interface SpinnerProps extends ActivityIndicatorProps {
  visible?: undefined | boolean
  cancelable?: boolean
  onDismiss?: () => void
}

const Spinner: React.FC<SpinnerProps> = ({
  visible,
  cancelable = false,
  onDismiss,
  size = 'large',
  color,
  testID = 'SPINNER',
  ...props
}) => {
  const theme = useTheme()

  const isVisible = Boolean(visible)

  if (!isVisible) {
    return null
  }

  const handleBackdropPress = () => {
    if (cancelable && onDismiss) {
      onDismiss()
    }
  }

  return (
    <Modal transparent visible={isVisible} animationType="none" testID={testID}>
      <Container>
        <TouchableWithoutFeedback onPress={handleBackdropPress}>
          <Backdrop testID={`${testID}_BACKDROP`} />
        </TouchableWithoutFeedback>
        <SpinnerWrapper>
          <ActivityIndicator
            size={size}
            color={color || theme.colors.lightGray}
            testID={`${testID}_INDICATOR`}
            {...props}
          />
        </SpinnerWrapper>
      </Container>
    </Modal>
  )
}

export default Spinner
